import React from 'react';
import ReferralList from '../components/partner-network/ReferralList';

const ReferralsPage: React.FC = () => <ReferralList />;

export default ReferralsPage;
